import { render, staticRenderFns } from "./AvalonBlockSettings.vue?vue&type=template&id=7f25d55e&scoped=true&"
import script from "./AvalonBlockSettings.vue?vue&type=script&lang=js&"
export * from "./AvalonBlockSettings.vue?vue&type=script&lang=js&"
import style0 from "./AvalonBlockSettings.vue?vue&type=style&index=0&id=7f25d55e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f25d55e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VExpandTransition,VIcon,VImg,VSheet})
